import { getStoreKeyByName } from "@/Steps";

const nameStoreFormValue = getStoreKeyByName('info')

const collectInfoFormData = [
  {
    id: 'usageData',
    label: 'Usage Data',
    subcategories: [],
    isCustomSubcategories: false,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  },
  {
    id: 'personalIdentificationInformation',
    label: 'Personal Identification Information',
    subcategories: [
      { id: 'fullName', label: 'Full Name', isCustom: false, value: false },
      { id: 'email', label: 'Email Address', isCustom: false, value: false },
      { id: 'mobilePhone', label: 'Mobile Phone Number', isCustom: false, value: false },
      { id: 'socialMediaProfiles', label: 'Social Media Profiles', isCustom: false, value: false },
      { id: 'dateOfBirth', label: 'Date of Birth', isCustom: false, value: false },
    ],
    isCustomSubcategories: true,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  },
  {
    id: 'contactInformation',
    label: 'Contact Information',
    subcategories: [
      { id: 'homeAddress', label: 'Home Address', isCustom: false, value: false },
      { id: 'workAddress', label: 'Work Address', isCustom: false, value: false },
      { id: 'postalAddress', label: 'Postal Address', isCustom: false, value: false },
    ],
    isCustomSubcategories: true,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  },
  {
    id: 'paymentInformation',
    label: 'Payment & Financial Information',
    subcategories: [
      { id: 'creditCardDetails', label: 'Credit/Debit Card Details (collected securely)', isCustom: false, value: false },
      { id: 'billingInformation', label: 'Billing Information', isCustom: false, value: false },
      { id: 'transactionHistory', label: 'Transaction History', isCustom: false, value: false },
    ],
    isCustomSubcategories: true,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  },
  {
    id: 'onlineIdentifiersAndDeviceInformation',
    label: 'Online Identifiers & Device Information',
    subcategories: [
      { id: 'ipAddress', label: 'IP Address', isCustom: false, value: false },
      { id: 'deviceIdentifiers', label: 'Device Identifiers (e.g., MAC address, IMEI)', isCustom: false, value: false },
      { id: 'browserTypeAndVersion', label: 'Browser Type and Version', isCustom: false, value: false },
      { id: 'operatingSystem', label: 'Operating System', isCustom: false, value: false },
    ],
    isCustomSubcategories: true,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  },
  {
    id: 'locationData',
    label: 'Location Data',
    subcategories: [
      { id: 'geolocation', label: 'Geolocation (GPS coordinates, location based on IP)', isCustom: false },
    ],
    isCustomSubcategories: true,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  },
  {
    id: 'demographicData',
    label: 'Demographic Data',
    subcategories: [
      { id: 'gender', label: 'Gender', isCustom: false, value: false },
      { id: 'ageRange', label: 'Age Range', isCustom: false, value: false },
      { id: 'incomeBracket', label: 'Income Bracket', isCustom: false, value: false },
      { id: 'educationLevel', label: 'Education Level', isCustom: false, value: false },
    ],
    isCustomSubcategories: true,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  },
  {
    id: 'communicationData',
    label: 'Communication Data',
    subcategories: [
      { id: 'customerSupportOrInquiryMessages', label: 'Customer Support or Inquiry Messages', isCustom: false, value: false },
      { id: 'chatLogs', label: 'Chat Logs', isCustom: false, value: false },
      { id: 'emailCorrespondence', label: 'Email Correspondence', isCustom: false, value: false },
    ],
    isCustomSubcategories: true,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  },
  {
    id: 'preferencesAndBehavioralData',
    label: 'Preferences and Behavioral Data',
    subcategories: [
      { id: 'userInterestsAndPreferences', label: 'User Interests and Preferences', isCustom: false, value: false },
      { id: 'productOrContentInteractionHistory', label: 'Product or Content Interaction History', isCustom: false, value: false },
    ],
    isCustomSubcategories: true,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  },
  {
    id: 'professionalInformation',
    label: 'Professional Information',
    subcategories: [
      { id: 'jobTitle', label: 'Job Title', isCustom: false },
      { id: 'companyName', label: 'Company Name', isCustom: false },
      { id: 'workEmail', label: 'Work Email', isCustom: false },
    ],
    isCustomSubcategories: true,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  },
  {
    id: 'userGeneratedContent',
    label: 'User-Generated Content',
    subcategories: [
      { id: 'commentsReviewsAndRatings', label: 'Comments, Reviews, and Ratings', isCustom: false, value: false },
      { id: 'forumOrCommunityPosts', label: 'Forum or Community Posts', isCustom: false, value: false },
    ],
    isCustomSubcategories: true,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  },
  {
    id: 'consentAndLegalDocuments',
    label: 'Consent and Legal Documents',
    subcategories: [
      { id: 'consentForms', label: 'Consent Forms', isCustom: false, value: false },
      { id: 'signedAgreements', label: 'Signed Agreements', isCustom: false, value: false },
    ],
    isCustomSubcategories: true,
    customSubcategories: [],
    value: false,
    retentionPeriod: '',
    legalBasis: '',
    isCustom: false,
  }
];

const wayCollectFormData = [
  {
    id: 'fillInAnyForms',
    label: 'Fill in any forms',
    value: false,
    isCustom: false,
  },
  {
    id: 'useOurServices',
    label: 'Use our Services',
    value: false,
    isCustom: false,
  },
  {
    id: 'correspondWithUs',
    label: 'Correspond with us',
    value: false,
    isCustom: false,
  },
  {
    id: 'speakWithSupportTeam',
    label: 'Speak with a member of our Clients’ support team',
    value: false,
    isCustom: false,
  },
  {
    id: 'contactUsForOtherReasons',
    label: 'Contact us for other reasons',
    value: false,
    isCustom: false,
  },
]

export const defaultValues = {
  collectInfo: collectInfoFormData,
  wayCollect: wayCollectFormData,
  legitimateSources: false,
  legitimateSourcesCategories: [
    {
      id: 'weMayReceivePersonal',
      label: 'We may receive personal data from entities with which we collaborate',
      value: true,
      isCustom: false,
    },
  ],
  publicSources: false,
  publicSourceValue: '',
  requiredByLaw: false,
  requiredByLawValue: '',
  requiredByContract: false,
  requiredByContractValue: '',
  consequencesIfNotProvidedValue: '',
}

export const informationFormState = set => ({
  [nameStoreFormValue]:  defaultValues,
  setInformationFormValue: value => set({ [nameStoreFormValue]: value}),
  resetInformationFormData: () => set({ [nameStoreFormValue]: defaultValues  }),
})